import Big from 'big.js'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { AnyToken } from 'src/common/types/models/Tokens'
import {
  bestOffersAtom,
  bestOffersModeAtom,
  buyTokenAmountAtom,
  offersToTakeAtom,
  skipOfferToTakeIdsAtom,
} from '../../../stores/trade-store'
import { big } from 'src/common/utils/big-utils'
import {
  containsUserNotAuthorizedOffers,
  getAuthAddressesFromOffers,
} from 'src/common/utils/offers'
import { authorizationsToQualifyAtom } from 'src/common/stores/store'

const useSwapFormControls = () => {
  const navigate = useNavigate()
  const setBuyTokenAmount = useSetAtom(buyTokenAmountAtom)
  const setAuthorizationsToQualify = useSetAtom(authorizationsToQualifyAtom)

  const [bestOffersMode, setBestOffersMode] = useAtom(bestOffersModeAtom)

  const skipOfferToTakeIds = useAtomValue(skipOfferToTakeIdsAtom)

  const bestOffers = useAtomValue(bestOffersAtom)
  const setOffersToTake = useSetAtom(offersToTakeAtom)

  const handleSellTokenAmountChange = () => {
    setBestOffersMode(0)
  }

  const handleBuyTokenAmountChange = () => {
    setBestOffersMode(1)
  }

  const handleAmountSelect = (value: number) => {
    setBuyTokenAmount(big(value))
    setBestOffersMode(1)
  }

  const handleBuyTokenChange = (token: AnyToken) => {
    if (token.type === 'ERC721' || token.type === 'ERC1155') {
      setBuyTokenAmount(Big(1))
      setBestOffersMode(1)
    }
  }

  const handleSwap = () => {
    setBestOffersMode(bestOffersMode === 0 ? 1 : 0)
  }

  const handleSwithToLimit = () => {
    navigate(`/trade/limit?no-swap`)
  }

  const handlePreviewClick = (route: 'swap' | 'invest' = 'swap') => {
    const offersToTake = bestOffers.filter(
      offer => !skipOfferToTakeIds.includes(offer.id)
    )
    const ids = offersToTake.map(offer => offer.id).join(',')
    setOffersToTake(offersToTake)
    navigate(`/trade/${route}/review?offers=${ids}`)
  }

  return {
    handleSellTokenAmountChange,
    handleBuyTokenAmountChange,
    handleBuyTokenChange,
    handleSwap,
    handleSwithToLimit,
    handlePreviewClick,
    handleAmountSelect,
  }
}

export default useSwapFormControls
